import API from 'services/API';

export default function checkExistingTaxAuthority(code) {
  return API.request({
    method: 'GET',
    url: `/taxAuthority/filtered/${code}`,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
    mapper: mapTaxAuthority,
  });
}

function mapTaxAuthority(data) {
  return { code: data.taxCode, name: data.name };
}
